const LISTAR_DADOS = (state, payload) => {
    state.items = payload
  }

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_TIPO_STATUS_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_TIPO_STATUS = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_TIPO_STATUS = (state, payload) => {
  state.items = state.items.map(item => {
    if(item.id === payload.id) {
      return payload;
    }
    return item
  })
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_TIPO_STATUS_SELECIONADO,
    INSERIR_TIPO_STATUS,
    ATUALIZAR_TIPO_STATUS
}